import type { ReactNode } from "react";
import { cx } from "./cx";
import { Icon } from "./icons";
import s from "./tick.module.css";

export interface TickProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name, e.g. "Done: Call the vendor". */
  label: string;
  /** Plays the pop animation once, right after a tick. */
  justChecked?: boolean;
  disabled?: boolean;
}

/** A checkbox button. The strike-through lives on the title: wrap it in `StrikeText`. */
export function Tick({ checked, onChange, label, justChecked, disabled }: TickProps) {
  return (
    <button type="button" role="checkbox" aria-checked={checked} aria-label={label} disabled={disabled} className={cx(s.tick, justChecked && checked && s.pop)} onClick={() => onChange(!checked)}>
      <Icon name="check" />
    </button>
  );
}

export function StrikeText({ done, animate, children }: { done: boolean; animate?: boolean; children: ReactNode }) {
  return <b className={cx(s.strike, done && s.done, done && animate && s.draw)} data-done={done || undefined}><span className={s.line}>{children}</span></b>;
}
